import { Add } from "@mui/icons-material";
import { Button } from "@mui/joy";
import React, { useEffect, useState } from "react";
import { tableUseStyle } from "../../etc/tableusestyle";
import { DataGridPremium, GridFilterModel, GridRowModel } from "@mui/x-data-grid-premium";
import NewTodoModal from "./newtodomodal";
import NewTodoModalForRegular from "./newtodomodalforregular";
import { getFetch, postFetch } from "../../../../../fetch/fetch";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Select, Option } from '@mui/joy';
import NewKakaoMessageModalRegular from "./newkakaomessagemodalregular";
import { addZeroIfOne } from "../../etc/etcfunctions";
import NewKakaoChatRoomModalRegular from "./newkakaochatroommodalregular";
import CustomInput from "../../etc/custominput";

const chatRoomNames = [
    "강남 데스크방",
    "강남 조교방",
    "대치점 2/3/6F 데스크 소통방",
    "대치 2F 데스크방",
    "대치 2F 조교방",
    "대치 3F 데스크방",
    "대치 3F 조교방",
    "대치 6F 데스크방",
    "대치 6F 조교방",
    "분당점 도시락방(사감방)",
    "송파점 데스크방",
    "송파점 도시락방(사감방)",
    "수능선배 분당점 메인데스크",
    "수능선배 수아쌤방",
    "(강남) 담임멘토팀장",
    "(대치) 담임멘토팀장",
    "(분당) 담임멘토팀장",
    "(종호) 멘토업무알려주는방",
    "w/보경",
    "송파 일요일 주간 당직",
    "대치 일요일 주야간 당직",
    "강남토야간,강남일주간 당직",
    "대치토야간,강남일야간 당직",
    "송파 일요일 야간 당직",
    "송파 토요일 야간 당직",
    "지점 환경 관리방",
    "(혜원) 질문방 / 강남토요일야간당직",
    "(나현) 질문방 / 강남일요일중간당직",
    "수능선배샤학관 개강 준비방",
    "수능선배 샤학관 데스크방",
    "수능선배 샤학관 사감방"
]


const RegularKakao: React.FC<any> = (props) => {

    const [open, setOpen] = useState<boolean>(false);
    const [columns, setColumns] = useState<any>([
        {
            field: "regular",
            headerName: "주기",
            width: 80,
        },
        {
            field: "time",
            headerName: "상세날짜",
            width: 180
        },
        {
            field: "hourminute",
            headerName: "시간",
            width: 100
        },
        {
            field: "projectName",
            headerName: "채팅방",
            width: 250
        },
        {
            field: "description",
            headerName: "내용",
            width: 500
        },
        {
            field: "author",
            headerName: "작성자",
            width: 100
        },
        {
            field: "createdAt",
            headerName: "작성일",
            width: 100
        },
        {
            field: "isActive",
            headerName: "활성화",
            width: 80,
            type: "boolean",
            editable: true
        }
    ]);
    const [rows, setRows] = useState<any>([]);
    const [allRows, setAllRows] = useState<any>([]);
    const classes = tableUseStyle();
    const [update, setUpdate] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedRowId, setSelectedRowId] = useState<number | null>(null);
    const [alignment, setAlignment] = useState("total");
    const [alignment2, setAlignment2] = useState("total");
    const [alignment3, setAlignment3] = useState("active");
    const [filterModel, setFilterModel] = useState<GridFilterModel>({
        items: [
            {
                id: 1,
                field: "projectName",
                operator: "contains",
                value: ""
            },
            {
                id: 2,
                field: "regular",
                operator: "contains",
                value: ""
            },
            {
                id: 3,
                field: "isActive",
                operator: "is",
                value: "true"
            }
        ],
    });
    const [isEditMode, setIsEditMode] = useState<boolean>(false);
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [chatRoomNames, setChatRoomNames] = useState<string[]>([]);
    const [update2, setUpdate2] = useState<number>(0);

    const [open2, setOpen2] = useState<boolean>(false);
    const [searchText, setSearchText] = useState<string>("");

    useEffect(() => {

        getKakaoChatRoomNames();

    }, [update2]);

    const getKakaoChatRoomNames = async () => {

        try {

            const result: any = await getFetch("/dashboard/todoist/getKakaoChatRoomNames");

            console.log(result);

            if (result.message === "success") {

                const chatRoomNames = result.chatRoomNames;
                setChatRoomNames([...chatRoomNames])

            }

        } catch (e) {
            console.log(e);
        }

    }

    useEffect(() => {

        console.log("gogogo");


        getRegularTodos();

    }, [update]);

    const getRegularTodos = async () => {

        try {

            setLoading(true);

            const result: any = await getFetch("/dashboard/todoist/getRegularKakaos");

            console.log(result);

            const data = result.data;

            const newRows: any = [];

            console.log(3);

            data.forEach((each: any) => {

                const oneRow: any = {};

                oneRow.id = each.id;

                oneRow.projectName = each.selectedProjectId;

                oneRow.regularType = each.regularType;

                const excludeDays = each.excludeDays;

                const fullDays = [0, 1, 2, 3, 4, 5, 6];

                const selectedDays = fullDays.filter((eachDay: number) => {
                    return !excludeDays.includes(eachDay);
                })

                oneRow.selectedDays = selectedDays;

                var string: string = "";

                selectedDays.forEach((eachDay: number, index: number) => {


                    const koreanDays = ["일", "월", "화", "수", "목", "금", "토"];

                    if (!koreanDays[eachDay]) {
                        return;
                    }

                    string += koreanDays[eachDay];

                    if (index !== selectedDays.length - 1) {
                        string += ", ";
                    }

                });

                if (each.regularType === "daily") {
                    oneRow.time = string;
                }


                oneRow.regular = each.regularType === "daily" ? "매일" : each.regularType === "weekly" ? "매주" : each.regularType === "monthly" ? "매월" : "매년";

                oneRow.dayString = each.dayString;
                oneRow.dateString = each.dateString;

                if (each.regularType === "weekly") {
                    var koreanDayString = "";

                    switch (each.dayString) {
                        case "mon":
                            koreanDayString = "월요일";
                            break;
                        case "tue":
                            koreanDayString = "화요일";
                            break;
                        case "wed":
                            koreanDayString = "수요일";
                            break;
                        case "thu":
                            koreanDayString = "목요일";
                            break;
                        case "fri":
                            koreanDayString = "금요일";
                            break;
                        case "sat":
                            koreanDayString = "토요일";
                            break;
                        case "sun":
                            koreanDayString = "일요일";
                            break;
                    }

                    oneRow.time = koreanDayString;

                }

                if (each.regularType === "monthly") {
                    oneRow.time = `${each.dateString}일`;
                }

                oneRow.isActive = each.isActive;
                oneRow.hourminute = `${addZeroIfOne(each.selectedHours)}:${addZeroIfOne(each.selectedMinutes)}`;

                oneRow.selectedHours = each.selectedHours;
                oneRow.selectedMinutes = each.selectedMinutes;


                oneRow.author = each.name;

                oneRow.description = each.description;

                const createdAtDate = new Date(each.createdAt);

                oneRow.createdAt = `${createdAtDate.getFullYear()}-${createdAtDate.getMonth() + 1}-${createdAtDate.getDate()}`;

                newRows.push(oneRow);

            })

            console.log(newRows);

            setRows([...newRows]);
            setAllRows([...newRows]);

            setLoading(false);

        } catch (e) {
            console.log(e);
        }

    }

    const letsUpdate = () => {
        setUpdate(Math.random());
    }

    const letsDelte = async () => {

        if (!window.confirm("정말 삭제하시겠습니까?")) return;

        try {

            setLoading(true);

            await postFetch("/dashboard/todoist/deleteRegularKakaos", {
                id: selectedRowId
            });

            setLoading(false);

            letsUpdate();

        } catch (e) {
            console.log(e);
        }

    }

    const handleChange = (event: any, newAlignment: string | null) => {

        if (!newAlignment) return;

        const newFilterModel: any = filterModel;

        newFilterModel.items.forEach((item: any) => {

            if (item.field === "projectName") {
                item.value = newAlignment;
            }

            if (newAlignment === "total" && item.field === "projectName") {
                item.value = "";
            }

        })

        setFilterModel({ ...newFilterModel });

        setAlignment(newAlignment);

    };

    const handleChangeSearchText = (e: any) => {

        const value = e.target.value;

        setSearchText(value);

        if (!value) {
            setRows([...allRows]);
            return;
        }

        const newRows = [...allRows];

        const filteredRows = newRows.filter((each: any) => {
            if (each.projectName.includes(value) || each.description.includes(value)) {
                return true;
            }
            return false;
        });

        setRows([...filteredRows]);


    }

    const handleChange2 = (e: any, newAlignment: string) => {

        if (!newAlignment || newAlignment === alignment2) return;

        setAlignment2(newAlignment);

        const newFilterModel: any = filterModel;


        newFilterModel.items.forEach((each: any) => {
            if (each.id === 2) {
                switch (newAlignment) {
                    case "total":
                        each.value = "";
                        break;
                    case "everyday":
                        each.value = "매일";
                        break;
                    case "everyweek":
                        each.value = "매주";
                        break;
                    case "everymonth":
                        each.value = "매월";
                        break;
                    default:
                        each.value = "";
                        break;
                }
            }
        })

        setFilterModel({ ...newFilterModel });
    }

    const handleChange3 = (e: any, newAlignment: string) => {

        if (!newAlignment || newAlignment === alignment3) return;

        setAlignment3(newAlignment);

        const newFilterModel: any = filterModel;

        newFilterModel.items.forEach((each: any) => {
            if (each.id === 3) {
                switch (newAlignment) {
                    case "active":
                        each.value = "true";
                        break;
                    case "inactive":
                        each.value = "false";
                        break;
                }
            }
        })

        setFilterModel({ ...newFilterModel });
    }

    const handleEditCommit = React.useCallback(
        async (newRow: GridRowModel, old: any) => {

            var field = "";

            for (const [key, value] of Object.entries(newRow)) {
                if (value !== old[key]) {
                    field = key;
                }
            }

            if (!field) {
                console.log("no field edited");
                return old;
            }

            if(field !== "isActive"){
                return old;
            }

            console.log("edited field:", field);
            console.log(newRow[field]);

            const value = newRow[field];


            fetch("https://peetsunbae.com/dashboard/todoist/activateregularkakao", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include",
                body: JSON.stringify({
                    id: newRow.id,
                    field: field,
                    value: value
                })
            })

            return newRow;

        }, []
    );

    const handleProcessRowUpdateError = React.useCallback((error: Error) => {

        alert(error.message);
    }, []);

    return (
        <div style={{
            width: "96%"
        }}>
            <div style={{
                fontFamily: "Apple_B",
                marginTop: "50px",
                fontSize: "18px",
                display: "flex",
                alignItems: "center",
            }}>
                <div style={{
                    marginRight: "18px"
                }}>
                    반복 카카오 등록 내역
                </div>
                <div>
                    <Button variant="solid" startDecorator={<Add />} size="sm" onClick={(e: any) => { setOpen(true); }}>
                        추가하기
                    </Button>
                </div>
            </div>
            <div style={{
                height: "30px"
            }}></div>
            <div className={classes.root} style={{ height: "500px", width: "100%" }}>
                <div style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "12px"
                }}>
                    <div style={{
                        display: "flex",
                    }}>
                        <Select
                            sx={{
                                width: "350px",
                                marginRight: "24px",
                            }}
                            value={alignment}
                            onChange={(e, newValue: any) => {
                                if (newValue === undefined || newValue === null) {
                                    return;
                                }

                                handleChange("e", newValue);
                            }
                            }>
                            <Option value={"total"}>전체 채팅방</Option>
                            {
                                chatRoomNames.map((each: any, index: number) => {

                                    return (
                                        <Option value={each} key={index}>{each}</Option>
                                    )

                                })
                            }
                        </Select>
                        <CustomInput
                            value={searchText}
                            onChange={handleChangeSearchText}
                            placeholder="채팅방/내용 검색"
                        />
                        <div style={{ marginLeft: "24px" }}>
                            <ToggleButtonGroup
                                color="primary"
                                value={alignment2}
                                exclusive
                                onChange={handleChange2}
                            >
                                <ToggleButton value="total">전체</ToggleButton>
                                <ToggleButton value="everyday">매일</ToggleButton>
                                <ToggleButton value="everyweek">매주</ToggleButton>
                                <ToggleButton value="everymonth">매월</ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                        <div style={{ marginLeft: "24px" }}>
                            <ToggleButtonGroup
                                color="primary"
                                value={alignment3}
                                exclusive
                                onChange={handleChange3}
                            >
                                <ToggleButton value="active">활성화</ToggleButton>
                                <ToggleButton value="inactive">비활성화</ToggleButton>
                            </ToggleButtonGroup>
                        </div>
                    </div>
                    <div>
                        <Button variant="soft" color="primary"
                            onClick={() => {
                                setOpen2(true);
                            }}
                            sx={{
                                marginRight: "12px"
                            }}
                        >
                            카카오톡 채팅방 추가하기
                        </Button>
                        <Button variant="soft" color="warning"
                            disabled={!selectedRowId}
                            onClick={() => {
                                setIsEditMode(true);
                                setOpen(true);
                            }}
                            sx={{
                                marginRight: "12px"
                            }}
                        >
                            수정하기
                        </Button>
                        <Button variant="soft" color="danger"
                            disabled={!selectedRowId}
                            onClick={letsDelte}
                        >
                            삭제하기
                        </Button>
                    </div>

                </div>
                <DataGridPremium
                    rows={rows}
                    columns={columns}
                    density="compact"
                    loading={loading}
                    onRowClick={(e: any) => {
                        console.log(e.id);
                        setSelectedRowId(e.id);
                        setSelectedRow(e.row);
                    }}
                    filterModel={filterModel}
                    onFilterModelChange={(model) => {
                        setFilterModel(model);
                    }}
                    processRowUpdate={handleEditCommit}
                    onProcessRowUpdateError={handleProcessRowUpdateError}
                />
            </div>

            <NewKakaoMessageModalRegular open={open} handleClose={() => { setOpen(false); setIsEditMode(false); }} apiKey={props.apiKey}
                projects={props.projects} letsUpdate={letsUpdate}
                chatRoomNames={chatRoomNames}
                isEditMode={isEditMode}
                selectedRow={selectedRow}
            />

            <NewKakaoChatRoomModalRegular open={open2} handleClose={() => { setOpen2(false); setUpdate2(Math.random()); }}
            />


        </div>
    )
}

export default RegularKakao;